export const CLASS_PREFIX = "examspark-mark";
export const CLASS_REGEX = /examspark-mark-([\S]+)/;
export const ATTRIBUTE_NAME = "es-mark";

export type MarkBlocksConfigItem = {
  label: string;
  icon?: string;
  showLabel?: boolean;
  readonly?: boolean;
};

export type MarkBlocksConfig = Record<string, MarkBlocksConfigItem>;

declare module "ckeditor5" {
  interface EditorConfig {
    markBlocks?: MarkBlocksConfig;
  }
}
